module.exports = __webpack_public_path__ + "static/img/it.5dd499d6.svg";